import React from 'react';
import { Skeleton } from '@mui/material';
import ReadMoreText from '@pages/Pages/ReadMoreText';

const Description = ({
  description,
  isLoading
}: {
  description: string;
  isLoading: boolean;
}) => {
  return (
    <>
      {description && <ReadMoreText text={description} />}
      {isLoading && !description && (
        <Skeleton
          sx={{
            margin: '12px 0px 8px 0px',
            // this needs to be 50px x 50px on screens less than 540px
            '@media (max-width: 540px)': {
              width: '100% !important',
              height: '50px !important'
            },
            transform: 'none !important'
          }}
          height="40px"
          width="100%"
        />
      )}
    </>
  );
};

export default Description;
